import $ from 'jquery';
import 'select2';

const Select = {
  init: () => {
    const $select = $('.js-select');
    if ($select.length === 0) return;

    $select.each((_index, element) => {
      $(element).select2();
    });
  },
}

export default Select;